export default [1, 2, 3, 4, 5].map(number => {
    return { text: number, value: number };
}).concat([{
    text: '6 и более',
    value: 6,
}]);
